export enum CandidatePageType {
  resume_builder = 'resume_builder',
  profile = 'profile',
  preferences = 'preferences',
  support = 'supporot'
}